<template>
  <div class="product-lift-wrapper col-md-6 col-12 mb-4">
    <div v-if="true" class="product-lift product-lift-desktop row g-0">
      <div class="col-8 pr-2">
        <h3>{{ product.title.rendered }}</h3>
        <div class="product-content" v-html="filteredContent"></div>
        <a :href="product.link"
          >Katso tuotetiedot
          <i class="fal fa-long-arrow-right"></i>
        </a>
      </div>
      <div class="col-4">
        <img :src="getImage" alt="" loading="lazy" />
      </div>
      <div class="col-12 divider-line"></div>
      <div class="col-6">
        <p class="mb-0">Tarvittava käyttömäärä</p>
        <p class="product-calculated-value">{{ solveAmount }} t/ha</p>
      </div>
      <div class="col-6">
        <p class="mb-0">Kokonaistarve</p>
        <p class="product-calculated-value">
          {{ Math.ceil(solveAmount * selectedAmounts.area) }} t
        </p>
      </div>

      <div class="col-6">
        <p class="mb-0">Fosfori</p>
        <p class="product-calculated-value">{{ solveP }} kg/ha</p>
      </div>
      <div class="col-6">
        <p v-if="product.tuotekategoria.includes(152)" class="small">
          Fosforia ei tarvitse huomioida ravinnetaselaskelmissa.
        </p>
        <p
          v-else-if="
            product.tuotekategoria.includes(154) ||
            product.tuotekategoria.includes(153)
          "
          class="small"
        >
          Fosfori huomioitava ravinnetaselaskelmissa.
        </p>
      </div>

      <div class="col-auto">
        <a
          class="btn btn-primary"
          target="_blank"
          :href="`/tarjouspyynto/?tuoteet=${product.id}`"
        >
          Pyydä tarjous
        </a>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint vue/no-v-html: 0 */
import { mapGetters, mapState } from "vuex";
import { useMediaQuery } from "@vueuse/core";
import { imageSourceFromProduct } from "../../shared/helpers";

export default {
  name: "ProductLift",
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const isDesktop = useMediaQuery("(min-width: 768px)");
    return { isDesktop };
  },
  computed: {
    ...mapGetters(["getMaalaji", "getPhDelta"]),
    ...mapState(["selectedAmounts"]),
    getImage() {
      return imageSourceFromProduct(this.product);
    },
    filteredContent() {
      let contentHolder;
      if (this.product.acf.kuvaus?.length > 0)
        contentHolder = this.product.acf.kuvaus;
      else {
        const { content } = this.product;
        const { rendered } = content;
        contentHolder = rendered;
      }
      const split = contentHolder.split("\n");
      for (const s of split) {
        if (s.length > 0) {
          return s;
        }
      }
      return contentHolder;
    },
    solveAmount() {
      const kosteus = parseFloat(this.product.acf.kosteus.replace(",", "."));
      const nnk = parseFloat(
        this.product.acf.nopeavaikutteinen_neurtalointikyky.replace(",", ".")
      );
      return this.calculateAmount(kosteus, nnk);
    },
    solveP() {
      const fosfori = parseFloat(
        this.product.acf.ravinteet[3].value.replace(",", ".")
      );
      if (isNaN(fosfori)) {
        return 0;
      }
      return Math.round(this.solveAmount * fosfori * 10) / 10;
    },
  },
  methods: {
    calculateAmount: function (kosteus, nnk) {
      return (
        Math.round(
          (((this.getPhDelta / 0.4) * 20) / (((100 - kosteus) / 100) * nnk)) *
            this.getMaalaji *
            10
        ) / 10
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.product-lift-wrapper {
  .product-lift {
    height: 100%;
    justify-content: flex-start;
    padding: 2rem 1rem;

    &.product-lift-desktop {
      padding: 2rem 2rem;
    }

    align-items: flex-start;
    margin: 1rem 0;
    color: var(--bs-dark);
    background-color: var(--bs-beige);

    .product-tag {
      align-self: flex-start;
      background-color: var(--bs-green);
      padding: 0.5rem 1rem;

      p {
        margin: 0;
        font-weight: bold;
        color: var(--bs-light);
      }
    }

    h3 {
      font-weight: bold;
      @media screen and (max-width: 768px) {
        font-size: 1.5rem;
      }
    }

    a:not(.btn) {
      color: var(--bs-red);
    }

    img {
      height: 100%;
      width: 100%;
      object-fit: contain;
      object-position: top;
    }

    div.product-content:deep(p),
    div.product-content:deep(strong) {
      @media screen and (max-width: 768px) {
        font-size: 16px;
      }
      font-weight: 400 !important;
    }

    div.product-amount:deep(p) {
      font-size: 16px;
    }

    .divider-line {
      margin-top: 1rem;
      height: 1px;
      background-color: var(--bs-red);
    }

    .product-calculated-value {
      font-weight: bolder;
      margin-top: 0.25rem;
    }

    .tarjous-button {
      display: flex;
      justify-content: flex-end;
    }

    .btn {
      @media screen and (max-width: 768px) {
        padding: 0.75rem;
      }
    }
  }
}
</style>
